import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import intl from 'react-intl-universal';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, Card, Popup, Toast, Modal } from 'antd-mobile';
import { DeleteOutline, RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';

import { selectBookingOption, selectOnlinePay, setOnlinePay } from '../../../store/reducers/hotel';
import Signature from '../../Signature';
import CurrencySymbol from '../../CurrencySymbol';
import { getStoreInfoByIdModel } from '../../../model/store';
import { formatJSON, getTimeZoneOffset, getUrlParam } from '../../../utils';
import { culTaxAndServiceFee, getActivePackageName, getProductLineAmount, hasActivePackagePrice } from '../../../utils/price';
import { getMemberInfo, setShoppingCart } from '../../../utils/storage/store';
import { getLanguageStore } from '../../../utils/storage/language';
import { getScopeParam, getHeadStoreInfoSession } from '../../../utils/session/store';
import math from '../../../utils/math';
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp';
import HouseIcon from '../../Icon/HouseIcon';
import CalendarIcon from '../../Icon/CalendarIcon';
import PeopleIcon from '../../Icon/PeopleIcon';
import ServeIcon from '../../Icon/ServeIcon';
import DatabaseIcon from '../../Icon/DatabaseIcon';
import CartFillIcon from '../../Icon/CartFillIcon';
import CouponIcon from '../../Icon/CouponIcon';
import BenefitIcon from '../../Icon/BenefitIcon';
import GiftIcon from '../../Icon/GiftIcon';
import PlusIcon from '../../Icon/PlusIcon';
import AttrString from '../../ProductMenu/AttrString';
import SelectCoupons from '../../CouponList/SelectCoupons';
import ExtendFormItem from '../../ExtendFormItem';
import RecommendMenu from './RecommendMenu';
import NumStepper from '../../NumStepper';
import ProductList from './ProductList';
import PriceDetails from './PriceDetails';
import ProductNum from './ProductNum';
import { handleFormValidationError } from '../../../utils/formValidation'
import { refreshLatLngToStorage } from '../../../utils/geolocation'
import { getMemberPackagesModel } from '../../../model/benefit';

import AttrSelectPopup from './AttrSelectPopup';

import useProductCalculations from '../../../hooks/useProductCalculations';
import useCouponLogic from '../../../hooks/useCouponLogic';// 优惠券相关逻辑
import useOrderSubmission from '../../../hooks/useOrderSubmission';// 订单提交逻辑

import './index.less';
import { all } from 'axios';

const COUPON_STYLE = {
    backgroundColor: '#FEC43F',
    padding: '2px 8px',
    borderRadius: '10px',
    color: '#000',
    display: 'inline-block'
}

// 主组件
const InputBookingData = ({ handleNext, isShow, productInfo = {}, from, products: oProducts = [], merchantInfo, hotMenus = [], previewFees = null }) => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [signatureImage, setSignatureImage] = useState(null)
    const [visible, setVisible] = useState(false)
    const [priceObj, setPriceObj] = useState({})
    const [storeInfo, setStoreInfo] = useState({})
    const [couponVisible, setCouponVisible] = useState(false)
    const [pdRemarkMap, setPdRemarkMap] = useState({})
    const [isLoadingStoreInfo, setIsLoadingStoreInfo] = useState(false)
    const [cartItems, setCartItems] = useState([])
    const [currentItem, setCurrentItem] = useState(null)
    const [attrVisible, setAttrVisible] = useState(false)
    const [recommendList, setRecommendList] = useState([])
    // const [productArr, setProductArr] = useState([])
    const [products, setProducts] = useState(oProducts)
    const [memberPackageName, setMemberPackageName] = useState('')
    const orderPromptShownRef = useRef(false)


    // 获取基础数据
    const scopeParam = getScopeParam()
    const onlinePay = useSelector(selectOnlinePay)
    const bookingOption = useSelector(selectBookingOption)
    const { selectedPeople, selectedDate, selectedTime } = bookingOption

    console.log(onlinePay, '=====///=====onlinePay=====///=====')

    // 计算选项字符串
    const optionStr = useMemo(() => {
        const peopleLabel = selectedPeople?.label
        const dateLabel = selectedDate?.label
        const month = selectedDate?.month
        const dateStr = dateLabel && month ? `${dateLabel} ${month}` : undefined
        const timeLabel = selectedTime?.label
        const ampm = selectedTime?.ampm

        return [peopleLabel, dateStr, timeLabel, ampm].filter(item => item !== undefined)
    }, [selectedPeople, selectedDate, selectedTime])

    // 解析扩展字段
    const { extendColumn1 = '' } = storeInfo || {}
    const loadedExt = formatJSON(extendColumn1) || {}
    const { otherItems = {}, payMethods, electronicSignature, isOpenProductRemark, canOrder, isOrderPromptPopup: loadedOrderPromptPopup } = loadedExt
    const storeExtReady = !!(storeInfo && Object.keys(storeInfo).length > 0 && storeInfo.extendColumn1)
    const merchantExt = formatJSON(merchantInfo?.extendColumn1) || {}
    const isOrderPromptPopup = storeExtReady ? !!loadedOrderPromptPopup : !!merchantExt.isOrderPromptPopup

    const { notes, extendColumn, bookingInstructions } = productInfo || {}
    const productExtendData = formatJSON(extendColumn) || {}
    const eSignature = electronicSignature || productExtendData.electronicSignature || false

    const nNotes = notes || merchantInfo?.storeInfo?.notes || merchantInfo?.notes || ''
    const nBookingInstructions = bookingInstructions || merchantInfo?.storeInfo?.bookingInstructions || merchantInfo?.bookingInstructions || ''
    const nOrderPromptMessage = merchantInfo?.storeInfo?.orderPromptMessage || merchantInfo?.orderPromptMessage || ''

    // 获取ID信息
    const storeId = merchantInfo?.storeId || getUrlParam('storeid') || productInfo?.storeId || ''
    const thirdPartyPreview = merchantInfo?.thirdPartyPreviewCalculate === true
    const areaId = getUrlParam('areaid') || scopeParam?.areaId || ''
    const chainInfo = getHeadStoreInfoSession()
    // const onlyDisplay = getOnlyDisplayStore()
    const onlyDisplay = merchantInfo?.storeArea?.isForDisplayOnly || chainInfo?.isForDisplayOnly || false
    // 获取商品价格
    const getProductPrice = (product) => getProductLineAmount(product, true)
    const checkoutProducts = products.length > 0 ? products : [productInfo]
    const hasEquityPackage = hasActivePackagePrice(checkoutProducts)
    const productPackageName = getActivePackageName(checkoutProducts)
    const equityPackageName = productPackageName || memberPackageName

    // 使用自定义hooks
    const { getProductList, getProductTotalMoney } = useProductCalculations(products, pdRemarkMap, productInfo, storeInfo)
    const { couponList, couponInfo, giftProduct, handleUseCoupon, getCouponList, setCouponInfo, updateCouponAmount } =
        useCouponLogic(
            storeId,
            products.length > 0 ? products : [{ ...productInfo, amount: getProductPrice(productInfo) }],
            priceObj,
            storeInfo
        )
    const activeCouponInfo = hasEquityPackage ? null : couponInfo
    const { loading, previewOrder } = useOrderSubmission(priceObj, signatureImage, activeCouponInfo, handleNext)

    useEffect(() => {
        if (!hasEquityPackage) return
        handleUseCoupon({ curCoupon: null })
        setCouponVisible(false)
    }, [hasEquityPackage, handleUseCoupon])

    useEffect(() => {
        if (!hasEquityPackage || productPackageName) {
            if (!hasEquityPackage) setMemberPackageName('')
            return
        }
        const { memberId = '' } = getMemberInfo() || {}
        if (!memberId) return
        let cancelled = false
        getMemberPackagesModel({
            memberId,
            language: getLanguageStore()
        }).then((raw) => {
            if (cancelled) return
            const list = Array.isArray(raw)
                ? raw
                : (raw?.records || raw?.list || raw?.packages || raw?.data || [])
            const first = Array.isArray(list) ? list[0] : null
            if (!first) {
                setMemberPackageName('')
                return
            }
            const pkg = first.package || first
            const rule = first.package_rule || first.packageRule || first
            setMemberPackageName(rule.name || rule.brandName || first.packageName || pkg.packageName || '')
        }).catch(() => {
            if (!cancelled) setMemberPackageName('')
        })
        return () => { cancelled = true }
    }, [hasEquityPackage, productPackageName])

    useEffect(() => {
        if (!merchantInfo) return
        const enableDisance = Number(merchantInfo.distanceLimit) && merchantInfo.distanceLimit > -1
        if (enableDisance) {
            refreshLatLngToStorage();
        }
    }, [merchantInfo]);

    // 处理签名保存
    const handleSave = useCallback((signatureImage) => {
        setSignatureImage(signatureImage)
        setVisible(false)
    }, [])

    // 获取其他输入值
    const getOtherInputValues = useCallback((formValues) => {
        const arr = Object.keys(otherItems)
        const obj = {}
        arr.forEach(item => {
            const { key, inputType, checkFlag, title } = otherItems[item]
            if (checkFlag === '3') return

            let valueStr = ''
            switch (inputType) {
                case 'text':
                case 'radio':
                    valueStr = formValues[key] || ''
                    break
                case 'checkbox':
                    valueStr = (formValues[key] || '').join()
                    break
                default:
                    break
            }
            if (valueStr) {
                obj[key] = { title: intl.get(key).d(title), key, value: valueStr }
            }
        })
        return obj
    }, [otherItems])

    // 提交表单
    const onSubmit = useCallback(() => {
        form.validateFields().then(values => {
            if (eSignature && !signatureImage) {
                Toast.show(intl.get('pls_sign').d('请签名'))
                const $signEl = document.querySelector('.user-signature')
                $signEl.scrollIntoView({
                    block: 'center',
                    behavior: 'smooth'
                })
                return
            }

            const { email, phone, remark = '', hotelName, payMethod, firstName, lastName, roomNo, payWay, onlineMethod, startTimeDate, whatsAppId, roomDayPassUnitNo, address } = values
            const { memberId = '' } = getMemberInfo() || {}
            const products = getProductList()
            const totalPrice = math.add(productNetPrice, nPriceObj.pd_actual_price) //nPriceObj.pd_actual_price

            console.log(priceObj, '////====priceObj===', priceItem, nPriceObj)

            const extendColumn = {
                people: selectedPeople?.value,
                bookDate: selectedDate?.value,
                bookTime: selectedTime?.value,
                electronicSignature: '',
                hotelName: hotelName ? hotelName[0] : '',
                isOnlinePay: payWay === '1' || (onlineMethod && onlineMethod.length > 0)
            }


            if (extendColumn.isOnlinePay) {
                extendColumn.payMethod = onlinePay
            } else {
                if (Object.keys(payMethods).length > 0 && payMethod) {
                    const payMethodObj = payMethods[payMethod]
                    if (payMethodObj) {
                        extendColumn.payMethod = payMethodObj

                    }
                }
            }


            if (otherItems && Object.keys(otherItems).length > 0) {
                const otherObj = getOtherInputValues(values)
                if (Object.keys(otherObj).length > 0) {
                    extendColumn.otherObj = otherObj
                }
            }

            extendColumn.adultNum = values.adultNum || ''
            extendColumn.childrenNum = values.childrenNum || ''
            extendColumn.dinersNum = values.adultNum || values.childrenNum
                ? `${values.adultNum || 0}/${values.childrenNum || 0}`
                : ''
            extendColumn.whatsAppId = whatsAppId || ''
            extendColumn.roomDayPassUnitNo = roomDayPassUnitNo || ''
            extendColumn.address = address || ''
            const nDate = dayjs().format('YYYY-MM-DD')


            const param = {
                areaId,
                memberId,
                storeId,
                lang: getLanguageStore(),
                products,
                totalPrice,
                discountPrice: 0,
                timezoneOffset: getTimeZoneOffset(),
                lat: '',
                lng: '',
                remark,
                firstName,
                lastName,
                roomNo,
                phoneNumber: phone,
                email,
                areaType: chainInfo?.areaType || merchantInfo?.storeArea?.areaType,
                startTimeDate: startTimeDate ? new Date(`${nDate} ${startTimeDate}`).getTime() : ''
            }

            if (extendColumn.bookDate && extendColumn.bookTime) {
                param.startTimeDate = ''
            }

            param.extendColumn = JSON.stringify(extendColumn)

            if (productInfo?.type === 4) { //优惠券产品
                param.orderType = 2
            }


            const normalPriceObj = culTaxAndServiceFee(normalTotal, storeInfo, normalTotal)
            previewOrder({ param, onlinePay: { enable: extendColumn.isOnlinePay, data: onlinePay }, totalPriceObj, normalPriceObj, couponInfo, thirdPartyPreview })

            addBehaviorsRecord({
                behaviorType: 160200,
                behavior: 160217,
                storeId: storeId
            })
        }).catch(error => {
            handleFormValidationError(error)
        })
    }, [form, eSignature,
        signatureImage, getProductList,
        priceObj, selectedPeople,
        selectedDate, selectedTime,
        payMethods, otherItems, getOtherInputValues,
        chainInfo, previewOrder, areaId, storeId, thirdPartyPreview])

    // 渲染优惠券信息
    const renderUseCouponInfo = useCallback((currency) => {
        if (couponInfo) {

            if (couponInfo.info.couponType === 3) {
                return couponInfo.info.couponName
            } else {
                return (
                    <small style={COUPON_STYLE}>
                        - <CurrencySymbol currency={currency} />
                        {couponInfo.reduceAmount}
                    </small>
                )
            }
        } else {
            return intl.get('od_use_coupon').d('使用优惠券')
        }
    }, [couponInfo])

    // 更新购物车
    const updateCartItems = (newItems) => {
        setCartItems(newItems)
        setShoppingCart([...oProducts, ...newItems], storeId)
    }

    // 添加到购物车
    const addToCart = (item) => {
        setCartItems(prev => {
            const exists = prev.find(i =>
                i.productId === item.productId &&
                i.specsKey === item.specsKey &&
                i.attrKeys === item.attrKeys &&
                i.subAttrKeys === item.subAttrKeys
            )

            if (exists) {
                const newItems = prev.map(i => {
                    if (i.productId === item.productId &&
                        i.specsKey === item.specsKey &&
                        i.attrKeys === item.attrKeys &&
                        i.subAttrKeys === item.subAttrKeys) {
                        const newItem = { ...i, quantity: i.quantity + 1 }
                        return { ...newItem, amount: getProductPrice(newItem), fromRec: true }
                    }
                    return { ...i, amount: getProductPrice(i), fromRec: true }
                })
                updateCartItems(newItems)
                return newItems
            }

            const newItem = { ...item, quantity: 1 }
            const newItems = [...prev, { ...newItem, amount: getProductPrice(newItem), fromRec: true }]
            updateCartItems(newItems)
            return newItems
        })
    }

    // 从购物车移除
    const removeFromCart = (itemId, value, pd) => {
        setCartItems(prev => {
            const newItems = prev.reduce((acc, item) => {
                if (item.productId === pd.productId &&
                    item.specsKey === pd.specsKey &&
                    item.attrKeys === pd.attrKeys &&
                    item.subAttrKeys === pd.subAttrKeys) {
                    if (item.quantity > 1) {
                        const newItem = { ...item, quantity: item.quantity - 1 }
                        return [...acc, { ...newItem, amount: getProductPrice(newItem) }]
                    }
                    return acc
                }
                return [...acc, { ...item, amount: getProductPrice(item) }]
            }, [])

            updateCartItems(newItems)
            return newItems
        })
    }
    // 渲染商品操作按钮
    const renderProductActions = (item, cls) => {
        if (item.priceType === 2 || item.priceType === 3) return null
        if (item.stock === 0) return null
        const subAttrLen = item.attrs.flatMap(attr => attr.subAttrList || []).length
        if ((item.attrs.length > 0 || subAttrLen > 0) || item.specs?.length > 0) {
            return (
                <div>
                    <button
                        style={{ background: 'transparent', border: 'none', position: 'relative' }}
                        onClick={() => {
                            setCurrentItem({ ...item, addBehavior: true })
                            setAttrVisible(true)
                        }}
                    >
                        <PlusIcon width={24} height={24} color="var(--adm-color-primary)" />
                        <ProductNum items={cartItems} productId={item.productId} cls={cls} />
                    </button>
                </div>
            )
        }

        return (
            <NumStepper
                items={cartItems}
                onAdd={item => {
                    if (item.attrs && item.attrs.length > 0) {
                        setCurrentItem(item)
                    } else {
                        addToCart(item)
                    }
                }}
                onRemove={removeFromCart}
                curProduct={item}
                addBehavior={true}
                place={1}
            />
        )
    }

    // 获取店铺信息
    useEffect(() => {
        if (!storeId) return

        // 添加防抖，避免频繁调用
        const timeoutId = setTimeout(() => {
            // 防止重复请求
            if (isLoadingStoreInfo) return

            setIsLoadingStoreInfo(true)
            // const totalPrice = getProductTotalMoney()
            const totalPriceObj = getProductTotalMoney()
            const { normalTotal, totalIncludeFee } = totalPriceObj
            const allMoney = math.add(normalTotal, totalIncludeFee);

            getStoreInfoByIdModel({ storeId })
                .then(res => {
                    const priceObj = culTaxAndServiceFee(normalTotal, res, normalTotal)
                    setPriceObj({ totalPrice: normalTotal, ...priceObj })
                    setStoreInfo(res)
                    // 在获取店铺信息成功后获取优惠券列表
                    if (!hasEquityPackage) {
                        getCouponList(res, { totalPrice: allMoney, ...priceObj })
                    }
                })
                .catch(e => {
                    console.error(e)
                    setStoreInfo({})
                    setPriceObj({ totalPrice: normalTotal })
                })
                .finally(() => {
                    setIsLoadingStoreInfo(false)
                })
        }, 300) // 300ms 防抖

        return () => {
            clearTimeout(timeoutId)
            setStoreInfo({})
            setPriceObj({})
            dispatch(setOnlinePay({}))
        }
    }, [storeId]) // 依赖 storeId 和 cartItems

    // useEffect(() => {
    //     if (!storeId) return
    //     getRecommendProductListModel({
    //         storeId,
    //         pageSize: 10,
    //         pageNo: 1
    //     }).then(res => {
    //         const arr = res.filter(item => !products.map(item => item.productId).includes(item.productId))
    //         setRecommendList(arr)
    //     })
    // }, [storeId, products])

    useEffect(() => {
        const arr = [...oProducts, ...cartItems]
        // const nProducts = arr.filter(item => canOrderItem(item))
        setProducts(arr)
        console.log(arr, '====arr====///')
    }, [oProducts, cartItems])

    // 当 products 变化时，重新计算 priceObj 和优惠券
    useEffect(() => {
        if (products.length > 0 && storeInfo && Object.keys(storeInfo).length > 0) {
            // const productTotalMoney = getProductTotalMoney()
            const totalPriceObj = getProductTotalMoney()
            const { normalTotal, totalIncludeFee } = totalPriceObj
            // const allMoney = math.add(normalTotal, totalIncludeFee);


            const newPriceObj = culTaxAndServiceFee(normalTotal, storeInfo, normalTotal)
            setPriceObj({ totalPrice: normalTotal, ...newPriceObj })

            // console.log(couponList, '====couponList====///')

            // 更新优惠券列表中的金额
            if (!hasEquityPackage) updateCouponAmount(products, (processedData) => {
                if (activeCouponInfo) {
                    const { info } = activeCouponInfo
                    const curCoupon = processedData.find(item => item.couponId === info.couponId)
                    handleUseCoupon({ curCoupon, fromPriceObj: newPriceObj })
                }

            })
        }
    }, [products, storeInfo, hasEquityPackage])

    // 计算最终价格
    const productArr = getProductList()
    const pdCurrency = productArr[0]?.currency || ''
    // const productTotalMoney = getProductTotalMoney()
    const totalPriceObj = getProductTotalMoney()
    const { normalTotal, totalIncludeFee, productNetPrice } = totalPriceObj
    // const allMoney = math.add(normalTotal, totalIncludeFee);
    const nPriceObj = storeInfo && normalTotal > 0 ? culTaxAndServiceFee(normalTotal, storeInfo, normalTotal) : priceObj
    const priceItem = activeCouponInfo?.priceItem || nPriceObj
    const discountAmount = activeCouponInfo?.reduceAmount || 0

    const recommendProductIdsKey = products.map(item => item.productId).join(',')
    const recommendProductIds = useMemo(
        () => products.map(item => item.productId),
        [recommendProductIdsKey]
    )

    useEffect(() => {
        if (!isShow || !isOrderPromptPopup || !nOrderPromptMessage) {
            orderPromptShownRef.current = false
            return
        }
        if (orderPromptShownRef.current) return
        orderPromptShownRef.current = true
        const handler = Modal.show({
            content: (
                <div
                    className="order-prompt-popup"
                    dangerouslySetInnerHTML={{ __html: nOrderPromptMessage }}
                />
            ),
            closeOnAction: true,
            actions: [{
                key: 'confirm',
                text: intl.get('ok').d('确定'),
                primary: true
            }]
        })
        return () => {
            orderPromptShownRef.current = false
            handler.close()
        }
    }, [isShow, isOrderPromptPopup, nOrderPromptMessage])

    if (!isShow) return null

    return (
        <div className='input-table-data bg-white'>
            {
                hotMenus.length > 0 && (
                    <RecommendMenu
                        list={hotMenus}
                        events={{
                            handleClickImageAction: (item) => {
                                console.log(item, 'item')
                            },
                            renderProductActions
                        }}
                        // fromApp={true}
                        storeInfo={merchantInfo}
                        productIds={recommendProductIds}
                    />
                )
            }

            <div className='tb-detail-content'>
                {productArr.length > 0 && (
                    <div className='bk-pd-box'>
                        <ul className='bk-list-wrapper'>
                            <li className='jm-flex'>
                                <div className='bk-left'>
                                    <HouseIcon width={23} height={23} color="var(--adm-color-primary)" />
                                </div>
                                <div className='bk-right jm-flex-item'>
                                    <label>{intl.get('h_merchant').d('Merchant')}</label>
                                    <div className='bk-txt'>{storeInfo.name}</div>
                                </div>
                            </li>

                            {optionStr.length > 0 && (
                                <>
                                    <li className='jm-flex'>
                                        <div className='bk-left'>
                                            <CalendarIcon width={24} height={24} color="var(--adm-color-primary)" />
                                        </div>
                                        <div className='bk-right jm-flex-item'>
                                            <label>{intl.get('h_date').d('Date')}</label>
                                            <div className='bk-txt'>
                                                {selectedDate?.label} {selectedDate?.month}. {selectedTime?.label} {selectedTime?.ampm}
                                            </div>
                                        </div>
                                    </li>
                                    {
                                        selectedPeople &&
                                        <li className='jm-flex'>
                                            <div className='bk-left'>
                                                <PeopleIcon width={24} height={24} color="var(--adm-color-primary)" />
                                            </div>
                                            <div className='bk-right jm-flex-item'>
                                                <label>{intl.get('person_num').d('Number of people')}</label>
                                                <div className='bk-txt'>{selectedPeople?.label}</div>
                                            </div>
                                        </li>
                                    }
                                </>
                            )}

                            <li className='jm-flex'>
                                <div className='bk-left'>
                                    {from === 'spa' ? <ServeIcon width={24} height={24} color="var(--adm-color-primary)" /> : <CartFillIcon width={24} height={24} color="var(--adm-color-primary)" />}
                                </div>
                                <div className='bk-right jm-flex-item'>
                                    <label>{from === 'spa' ? intl.get('service_option').d('Service') : intl.get('app_items').d('Items')}</label>
                                    <ProductList
                                        productArr={productArr}
                                        isOpenProductRemark={isOpenProductRemark}
                                        pdRemarkMap={pdRemarkMap}
                                        setPdRemarkMap={setPdRemarkMap}
                                        from={from}
                                        hideFeeRate={thirdPartyPreview}
                                        events={{
                                            removeFromCart
                                        }}
                                    />
                                    {!hasEquityPackage && giftProduct && (
                                        <div className='bk-product-item'
                                            key={giftProduct.productId}
                                            style={{ paddingRight: 20 }}>
                                            <div className='jm-flex' style={{ gap: 10 }}>
                                                <div className='jm-flex-item jm-flex'>
                                                    <span>
                                                        <GiftIcon width={14} height={14} color='#FF9800' />&nbsp;
                                                    </span>
                                                    <span>{giftProduct.productName}</span>
                                                    <AttrString product={giftProduct} />
                                                </div>
                                                <div className='jm-price' style={{ borderRight: '1px solid #eae8e8', paddingRight: 10 }}>0</div>
                                                <div className='text-gray'><small>X</small>1</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </li>
                        </ul>
                        {hasEquityPackage ? (
                            <ul className='bk-list-wrapper m-t-sm'
                                style={{ backgroundColor: 'var(--adm-color-primary)', padding: '8px 15px', color: '#fff' }}
                            >
                                <li className='jm-flex' style={{ alignItems: 'center' }}>
                                    <div className='bk-left'>
                                        <span style={{ marginLeft: 2 }}>
                                            <BenefitIcon width={20} height={20} color="#fff" />
                                        </span>
                                    </div>
                                    <div className='bk-right jm-flex-item'>
                                        <article className='bk-price-list'>
                                            <section className='jm-flex' style={{ background: 'transparent', paddingRight: 0 }}>
                                                <div className='jm-flex-item'><b>{intl.get('od_benefit_package').d('权益包')}</b></div>
                                                <div className='ellips' style={{ maxWidth: '70%', textAlign: 'right' }}>
                                                    {equityPackageName}
                                                </div>
                                            </section>
                                        </article>
                                    </div>
                                </li>
                            </ul>
                        ) : couponList.length > 0 ? (
                            <ul className='bk-list-wrapper m-t-sm'
                                style={{ backgroundColor: 'var(--adm-color-primary)', padding: '8px 15px', color: '#fff' }}
                            >
                                <li className='jm-flex' style={{ alignItems: 'center' }}>
                                    <div className='bk-left'>
                                        <span style={{ marginLeft: 2 }}>
                                            <CouponIcon width={20} height={20} color="#fff" />
                                        </span>
                                    </div>
                                    <div className='bk-right jm-flex-item'>
                                        <article className='bk-price-list'>
                                            <section className='jm-flex' style={{ background: 'transparent', paddingRight: 0 }}>
                                                <div className='jm-flex-item'><b>{intl.get('od_coupon').d('Coupon')}</b></div>
                                                <div
                                                    className='jm-coupon'
                                                    onClick={() => {
                                                        addBehaviorsRecord({
                                                            behaviorType: 160200,
                                                            behavior: 160211
                                                        })
                                                        setCouponVisible(true)
                                                    }}
                                                >
                                                    <div className='jm-flex' style={{ gap: 4 }}>
                                                        <div className='ellips' style={{ width: 100, textAlign: 'right' }}>
                                                            {renderUseCouponInfo(pdCurrency)}
                                                        </div>
                                                        <RightOutline fontSize={12} />
                                                    </div>
                                                </div>
                                            </section>
                                        </article>
                                    </div>
                                </li>
                            </ul>
                        ) : null}
                        <ul className='bk-list-wrapper m-t-sm'>
                            <li className='jm-flex' style={{ alignItems: 'flex-start' }}>
                                <div className='bk-left'>
                                    <DatabaseIcon width={24} height={24} color="var(--adm-color-primary)" />
                                </div>
                                <div className='bk-right jm-flex-item'>
                                    <PriceDetails
                                        priceItem={priceItem}
                                        priceObj={priceObj}
                                        storeInfo={storeInfo}
                                        pdCurrency={pdCurrency}
                                        discountAmount={discountAmount}
                                        productPriceIncludeFee={totalIncludeFee}
                                        hideFeeRate={thirdPartyPreview}
                                        previewFees={thirdPartyPreview ? previewFees : null}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                )}

                <Form
                    size='small'
                    mode='card'
                    form={form}
                    className='table-form m-t-sm'
                    initialValues={{ names: { preValue: 1, realValue: '' } }}
                >
                    {storeInfo && (
                        <ExtendFormItem
                            storeInfo={storeInfo}
                            productExtendData={productExtendData}
                        />
                    )}
                </Form>

                {nBookingInstructions && (
                    <Card
                        className='m-t-sm'
                        size="small"
                        title={intl.get('book_tips1').d('Booking notice')}
                        bodyStyle={{ padding: '5px 0' }}>
                        <div className='booking-notice' style={{ whiteSpace: 'pre-wrap', lineHeight: 1.3 }}>
                            {nBookingInstructions}
                        </div>
                    </Card>
                )}

                {nNotes && (
                    <Card className='m-t-sm' size="small" title={intl.get('notice_item1').d('Notice')}
                        bodyStyle={{ padding: '5px 0' }}>
                        <div className='booking-notice' style={{ whiteSpace: 'pre-wrap', lineHeight: 1.3 }}>
                            {nNotes}
                        </div>
                    </Card>
                )}

                {eSignature && (
                    <Card className='m-t-sm' bodyStyle={{ paddingLeft: 0 }}>
                        <div style={{ fontSize: 15, fontWeight: 'bold', marginBottom: 5 }}>
                            {intl.get('ele_signature').d('Electronic signature')}
                            <span className='text-danger'>*</span>
                        </div>
                        <div className='user-signature' onClick={() => setVisible(true)}>
                            {signatureImage ? (
                                <div className='pos-rel'>
                                    <img src={signatureImage} alt="signature" style={{ width: '100%', height: '100%' }} />
                                    <div
                                        className='del-sign text-center'
                                        onClick={e => {
                                            e.stopPropagation()
                                            setSignatureImage(null)
                                        }}
                                    >
                                        <DeleteOutline fontSize={24} />
                                    </div>
                                </div>
                            ) : (
                                <Button>{intl.get('click_to_sign').d('点击签名')}</Button>
                            )}
                        </div>
                    </Card>
                )}

                {nOrderPromptMessage && (
                    <div
                        className='p10 text-danger order-prompt-html'
                        style={{ whiteSpace: 'pre-wrap', paddingLeft: 16 }}
                        dangerouslySetInnerHTML={{ __html: nOrderPromptMessage }}
                    />
                )}
            </div>

            {canOrder === 1 && !onlyDisplay && (
                <div className='tb-ft-view'>
                    <div className='tb-ft-btn-bar'>
                        <Button
                            block
                            color='primary'
                            onClick={onSubmit}
                            loading={loading}
                        >
                            {intl.get('submit').d('Submit')}
                        </Button>
                    </div>
                </div>
            )}

            <Popup
                visible={visible}
                onClose={() => setVisible(false)}
                destroyOnClose
                showCloseButton
            >
                <Signature
                    width={window.innerWidth}
                    height={150}
                    onSave={handleSave}
                />
            </Popup>

            <Popup
                visible={!hasEquityPackage && couponVisible}
                onClose={() => {
                    setCouponVisible(false)
                    //不使用优惠券
                    addBehaviorsRecord({
                        behaviorType: 160200,
                        behavior: 160213
                    })
                }}
                destroyOnClose
                showCloseButton
            >
                <div className='coupon-list'>
                    <SelectCoupons
                        list={couponList}
                        from='coupons'
                        callback={(curCoupon) => {
                            if (curCoupon) {
                                handleUseCoupon({ curCoupon, fromPriceObj: nPriceObj })
                                //使用优惠券
                                addBehaviorsRecord({
                                    behaviorType: 160200,
                                    behavior: 160212,
                                    value1: curCoupon.couponRuleId
                                })
                            } else {
                                setCouponInfo(null)
                                //不使用优惠券
                                addBehaviorsRecord({
                                    behaviorType: 160200,
                                    behavior: 160213
                                })
                            }
                            setCouponVisible(false)
                        }}
                    />
                </div>
            </Popup>

            {/* 属性选择弹窗 */}
            {currentItem !== null && attrVisible && (
                <AttrSelectPopup
                    visible={attrVisible}
                    onClose={() => setAttrVisible(false)}
                    product={currentItem}
                    addToCart={addToCart}
                    placeFlag={1}
                />
            )}
        </div>
    )
}

export default InputBookingData
